var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter" },
    [
      _c(
        "el-select",
        {
          staticClass: "filter-nav",
          attrs: { "popper-append-to-body": false, placeholder: "请选择" },
          on: { change: _vm.onChange },
          model: {
            value: _vm.value,
            callback: function($$v) {
              _vm.value = $$v
            },
            expression: "value"
          }
        },
        _vm._l(_vm.list, function(item) {
          return _c("el-option", {
            key: item.id,
            attrs: { label: item.name, value: item.id }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }